import { Button, Grid, Icon, Input, Select } from '@scuf/common';
import { IOption } from '@scuf/common/dist/components/Select/ISelectProps';
import useFetch from 'helpers/hooks/useFetch';
import { AddressModel, RmaModel, RmaModelLite } from 'models';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { REPAIR_CENTER, Rma, cepMask, notificationAtom } from 'resources';
import { getStatesAndInitials } from 'resources/api/externalApi';

interface ChangeStatusProps {
    rmaState: RmaModelLite;
    setRmaState: React.Dispatch<React.SetStateAction<RmaModelLite>>;
}

function AdmAddressAccordion({ rmaState, setRmaState }: ChangeStatusProps): JSX.Element {
    const { t } = useTranslation(['user', 'common']);
    const [fields, setFields] = useState<AddressModel>(rmaState.address);
    const [states, setStates] = useState<IOption[]>([]);
    const [change, setChange] = useState<boolean>(false);
    const setNotification = useSetRecoilState(notificationAtom);
    const [addressComplement, setAddressComplement] = useState(rmaState?.addressComplement || '');
    const [addressNumber, setAddressNumber] = useState(rmaState?.addressNumber || '');


    const handleChange = (field: string, value: any): void => {
        setChange(true);
        setFields(old => ({ ...old, [field]: value }));
    };


    const handleChangeAddressComplement = (value: string): void => {
        setChange(true);
        setAddressComplement(value);
    };

    const handleAddressNumber = (value: string): void => {
        setChange(true);
        setAddressNumber(value);
    };


    const handleCancel = (): void => {
        setChange(false);
        setFields(rmaState.address);
    };
    const getStates = async (): Promise<IOption[]> => {
        const resp: { status: number; data: any } = await getStatesAndInitials();
        let options: { value: string; text: string }[] = [];
        if (resp.status === 200) {
            options = resp.data.map((e: any) => ({ value: e.sigla, text: e.nome }));
        }
        return options;
    };
    const [, changeAddressData, loading] = useFetch<RmaModelLite>({
        url: REPAIR_CENTER.alterAddressInRma,
        method: 'POST',
        onSuccess: 'Change',
        onError: 'Change'
    });

    const handleSave = async (): Promise<void> => {
        await changeAddressData(
            { ...rmaState, id: rmaState.id, address: fields, addressComplement, addressNumber },
            current => {
                setRmaState(old => ({
                    ...old,
                    address: fields,
                    addressComplement,
                    addressNumber
                }));
                setChange(false);
            }
        );
    };


    useEffect(() => {
        getStates().then(value => setStates(value));
    }, []);


    return (
        <>
            <Grid>
                <Grid.Column className="grid-with-gap">
                    <Input
                        maxLength={9}
                        value={cepMask(fields?.zipCode)}
                        label={t('address.ZipCode')}
                        onChange={value => handleChange('zipCode', value.replace(/\D/g, ''))}
                    ></Input>
                    <Select
                        value={fields?.state}
                        label={t('address.State')}
                        options={states}
                        onChange={value => handleChange('state', value)}
                    ></Select>
                    <Input value={fields?.city} label={t('address.City')} onChange={value => handleChange('city', value)}></Input>
                    <Input
                        value={fields?.neighborhood}
                        label={t('address.Neighborhood')}
                        onChange={value => handleChange('neighborhood', value)}
                    ></Input>
                </Grid.Column>
                <Grid.Column className="grid-with-gap">
                    <Input
                        value={fields?.street}
                        label={t('address.Street')}
                        onChange={value => handleChange('street', value)}
                    ></Input>
                    <Input
                        value={addressNumber}
                        label={t('address.Number')}
                        onChange={value => handleAddressNumber(value)}
                    ></Input>
                    <Input
                        value={addressComplement}
                        label={t('address.Complement')}
                        onChange={value => handleChangeAddressComplement(value)}
                    ></Input>
                </Grid.Column>
            </Grid>
            <>
                {change && (
                    <div className="buttonsSearch">
                        <Button
                            content={t('common:actions.Cancel')}
                            type="secondary"
                            onClick={handleCancel}
                            loading={loading}
                            disabled={loading}
                        ></Button>
                        <Button
                            content={t('common:actions.Save')}
                            iconPosition="right"
                            icon={<Icon root="common" name="save" />}
                            loading={loading}
                            disabled={loading}
                            onClick={handleSave}
                        ></Button>
                    </div>
                )}
            </>
        </>
    );
}

export default AdmAddressAccordion;
